// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import theme from '../../styled-components/dark';

const StyledButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${theme.RoundedButton.secondaryButtonBackgroundColor};
  color: ${theme.RoundedButton.bonusTitle};
  user-select: none;
  cursor: pointer;
  border-radius: 1.3em;
  padding: 0.3em 0.8em;

  &:active {
    transform: scale(0.95);
  }
`;

const ButtonTitle = styled.div`
  &:first-letter {
    text-transform: uppercase;
  }

  ${({ $iconLeft }) =>
    $iconLeft
      ? css`
          padding-left: 0.4em;
        `
      : css`
          padding-right: 0.6em;
        `}
`;

const DynamicIcon = styled.svg`
  color: ${theme.RoundedButton.iconButtonColor};
  width: 0.9em;
  height: 0.9em;

  ${({ $style }) => $style};
`;

type RoundedButtonWithIconProps = {
  className?: string;
  onClick: () => void;
  label: string;
  SVGIcon: unknown;
  SVGIconStyle?: unknown;
  iconLeft?: boolean;
};

const RoundedButtonWithIcon = ({
  className,
  onClick,
  label,
  SVGIcon,
  SVGIconStyle,
  iconLeft = false,
}: RoundedButtonWithIconProps) => {
  return (
    <StyledButton className={className} onClick={onClick}>
      {iconLeft ? <DynamicIcon as={SVGIcon} $style={SVGIconStyle} /> : null}
      <ButtonTitle $iconLeft={iconLeft}>{label}</ButtonTitle>
      {!iconLeft ? <DynamicIcon as={SVGIcon} $style={SVGIconStyle} /> : null}
    </StyledButton>
  );
};

export default RoundedButtonWithIcon;
